module.exports = __webpack_public_path__ + "img/ayhf.9eda83cc.jpg";